<template>
  <div>
    <b-table
      :data="sales"
      :loading="loading"
      :paginated="true"
      :per-page="10"
      :striped="true"
      :hoverable="true"
    >
      <!-- ID -->
      <b-table-column field="id" label="ID" width="50" numeric v-slot="props">
        {{ props.row.id }}
      </b-table-column>

      <!-- Fecha -->
      <b-table-column field="created_at" label="Fecha" v-slot="props">
        {{ props.row.created_at }}
      </b-table-column>

      >

      <!-- Acciones -->
      <b-table-column label="Acciones" v-slot="props">
        <b-button
          type="is-info"
          size="is-small"
          @click="$router.push(`/ventas/id/${props.row.id}`)"
        >
          Ver venta
        </b-button>
      </b-table-column>

      <!-- Sin datos -->
      <template #empty>
        <div class="has-text-centered p-4">
          <p>No se encontraron ventas para este contacto.</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ContactSales",

  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      sales: [],
      loading: false,
    };
  },

  watch: {
    contactId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchSales(newVal);
        }
      },
    },
  },

  methods: {
    async fetchSales(contactId) {
      this.loading = true;
      try {
        const response = await this.$repositories.sales.salesByContact(
          contactId
        );
        this.sales = (response.data.sales || []).map((sale) => ({
          id: sale.id,
          created_at: sale.created_at?.split("T")[0] ?? "Sin fecha",
          total: `$${Number(sale.total ?? 0).toFixed(2)}`,
        }));
      } catch (error) {
        console.error("Error al cargar ventas:", error);
        this.sales = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
